/**
 * Optimize Next の `window.optimize_next.get()` 戻り値を A/B バリアントへマッピングする純粋ロジック。
 *
 * Vue/Nuxt に一切依存しない（core/ 配下）。SSR・クライアント双方で同一に動作し、Vitest でテストする。
 *
 * - `0`            → 'control'（オリジナル）
 * - `1` 以上       → 'variant'（パターン1+。複数 variant も variant 扱い）
 * - `undefined`    → null（エクスペリエンス未発火/未割当）
 * - 負値 / NaN / Infinity / 0 < n < 1 などの異常値 → null（安全側で未割当扱い）
 */
export type AbVariant = 'control' | 'variant';

export const mapOptimizeNextPattern = (pattern: number | undefined): AbVariant | null => {
  if (pattern === undefined) return null;
  // NaN / Infinity / -Infinity を除外（Infinity は後段の `>= 1` をすり抜けるため先に弾く）
  if (!Number.isFinite(pattern)) return null;
  if (pattern === 0) return 'control';
  if (pattern >= 1) return 'variant';
  // 負値や 0 < n < 1 は仕様外 → 未割当扱い
  return null;
};
